import { atom } from "recoil"

export const templateRequestIdState = atom({
  key: "atoms/contact/create/templateRequestIdState",
  default: 0,
})
